<template>
  <span
    v-if="!editable || !isEditing"
    :class="{ 'cursor-pointer': editable }"
    v-bind="$attrs"
    @click="startEditing"
  >
    {{ formattedAmount }}
  </span>
  <input
    v-else
    ref="input"
    type="text"
    :value="formattedAmount"
    v-bind="$attrs"
    @change="onChange"
    @blur="isEditing = false"
    @keydown.enter="$event.target.blur()"
  >
</template>
<script>

export default {
  inheritAttrs: false,
  props: {
    amount: {
      required: true,
      type: Number,
    },
    editable: {
      default: false,
      type: Boolean,
    },
  },
  emits: ['update:amount'],
  data() {
    return {
      isEditing: false,
    };
  },
  computed: {
    formattedAmount() {
      return Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
      }).format(this.amount);
    },
  },
  methods: {
    startEditing() {
      if (!this.editable) return;
      this.isEditing = true;
      this.$nextTick(() => {
        this.$refs.input?.focus();
        this.$refs.input?.select();
      });
    },
    onChange(event) {
      const raw = event.target.value.replace(/[^0-9-]/g, '');
      const parsed = parseInt(raw, 10);
      if (!isNaN(parsed)) {
        this.$emit('update:amount', parsed);
      }
      this.isEditing = false;
    },
  },
};
</script>
